
import { mapGetters } from "vuex";
import ArticleSlider from "@/components/pages/articles/ArticleSlider.vue";
import LatestArticles from "@/components/pages/articles/LatestArticles.vue";
import { getImageByPosition, metaGenerator, normalizeI18nLinks } from "@/utils";
import useEvents from "~/mixins/useEvents";

export default {
  name: "ArticlesPage",
  components: {
    ArticleSlider,
    LatestArticles,
  },
  mixins: [useEvents],
  middleware({ params, redirect, localePath }) {
    if (params.section === "all" && !params.slug) {
      return redirect(localePath("/articles"));
    }
  },
  async asyncData({ $api, query, store, i18n, route }) {
    const getPage = async () => {
      try {
        const { data } = await $api.pages.getPage("posts");
        return data.data;
      } catch (err) {
        console.log("err - ", err?.response?.data?.errors);
      }
    };

    const getCategories = async () => {
      try {
        const { data } = await $api.blog.getBlogCategories();
        return data.data;
      } catch (err) {
        console.log("err - ", err?.response?.data?.errors);
      }
    };

    const getLatestArticles = async () => {
      try {
        const params = {
          count: 8,
          column: "created_at",
          order_by: "desc",
        };
        const { data } = await $api.blog.getPosts(params);
        return data;
      } catch (err) {
        console.log("err - ", err?.response?.data?.errors);
      }
    };
    const latestArticlesResp = await getLatestArticles();
    const latestArticles = latestArticlesResp.data.slice(1);
    const latestArticle = latestArticlesResp.data.slice(0, 1)[0];

    const blogCategories = await getCategories();
    const currentCategory = blogCategories.find(
      (category) => category.slug === query.section
    );

    if (!route.params.slug) {
      store.commit("general/SET_JSON_SCHEMA_DATA", {
        pageName:
          currentCategory?.mixedTranslation?.title || i18n.t("articles"),
        pageImage:
          getImageByPosition(currentCategory?.medias, "page")?.file?.url ||
          getImageByPosition(currentCategory?.medias, "list")?.file?.url,
      });
    }

    return {
      pageData: await getPage(),
      blogCategories,
      latestArticles,
      latestArticle,
      search: query.search,
      tabsList: [
        {
          url: "inspiration",
          label: "Inspiration",
        },
        {
          url: "lookbook",
          label: "Lookbook",
        },
        {
          url: "news",
          label: "News",
        },
        {
          url: "others",
          label: "Others",
        },
      ],
    };
  },
  head() {
    const i18nHead = this.$nuxtI18nHead({
      addSeoAttributes: true,
    });
    return {
      meta: [
        ...metaGenerator({
          title:
            this.selectedCategory?.meta_title ||
            this.selectedCategory?.title ||
            "",
          description: this.selectedCategory?.meta_description || "",
          image:
            this.pageData?.medias?.find((el) => el.position === "open-graph")
              ?.file?.url || "",
          keywords: this.selectedCategory?.meta_keywords || "",
          url:
            this.pageData?.mixedTranslation?.meta_url ||
            process.env.DOMAIN + this.$route.fullPath,
        }),
        ...i18nHead.meta,
      ],
      htmlAttrs: i18nHead.htmlAttrs,
      link: normalizeI18nLinks(i18nHead.link),
      title:
        this.selectedCategory?.meta_title || this.selectedCategory?.title || "",
      titleTemplate: `%s | ${this.getCompanyName}`,
    };
  },
  // mounted() {
  //   const element = document.querySelector(".blog__categories-and-search");
  //   element.scrollIntoView();
  // },
  computed: {
    ...mapGetters({
      getCompanyName: "general/getCompanyName",
    }),
    selectedCategory() {
      if (this.$route.params.section) {
        const section = this.blogCategories.find(
          (category) => category.slug === this.$route.params.section
        );
        return section
          ? section?.mixedTranslation
          : this.pageData?.mixedTranslation;
      }
      return this.pageData?.mixedTranslation;
    },
  },
  mounted () {
    this.visitEvent(this.pageData.is_plp);
  },
  methods: {
    onSearch() {
      const path = `${this.$route.path}?search=${this.search}`;
      this.$router.push(path);
    },
  },
};
